import { render, staticRenderFns } from "./AgentRank.vue?vue&type=template&id=0a939eaa&scoped=true&lang=pug&"
import script from "./AgentRank.vue?vue&type=script&lang=ts&"
export * from "./AgentRank.vue?vue&type=script&lang=ts&"
import style0 from "./AgentRank.vue?vue&type=style&index=0&id=0a939eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a939eaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
